import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidSplitting } from '../../../../mechanics/rid-splitting/rid-splitting';

@Component({
  selector: 'app-splitting-page',
  imports: [RidSplitting],
  templateUrl: './splitting-page.html',
})
export class SplittingPage {
  protected readonly $router = inject(Router);
}
